const styles = () => ({
  notification: {
    width: '100%',
    padding: '10px 20px',
    background: '#FFF7EC',
    borderTop: '1px solid #fde08e',
    borderLeft: '1px solid #fde08e',
    borderRight: '1px solid #fde08e',
    alignItems: 'center',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',

    '&:first-of-type': {
      borderTopLeftRadius: 7,
      borderTopRightRadius: 7,
    },

    '&:last-of-type': {
      borderBottom: '1px solid #fde08e',
      borderBottomLeftRadius: 7,
      borderBottomRightRadius: 7,
    },
  },
});

export default styles;
